let utils = {}
utils.Storage = window.sessionStorage;
utils.localStorage = window.localStorage;
export default utils



// WEBPACK FOOTER //
// ./src/utils/Storage.js